import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { pinDropdownTriggerToWidthCss } from "app/pages/sales-intelligence/common-components/dropdown/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const COLUMN_GAP = 12;

export const StyledRangeSelectText = styled.span`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon[400])};
`;

export const StyledRangeSelectContent = styled(FlexRow)<{ columnGap: number }>`
    column-gap: ${({ columnGap }) => columnGap}px;
    align-items: center;
    justify-content: flex-start;
    ${pinDropdownTriggerToWidthCss}
`;
